module.exports = __webpack_public_path__ + "img/shunfen.5d1baad2.jpg";